<template>
    <b-card :title="title" class="media-card">
        <b-form-file v-if="!disabled"
                     ref="input"
                     :placeholder="placeholder"
                     :accept="accept"
                     multiple
                     @change="e => $emit('upload', e)" />

        <b-progress v-if="progress > 0" :value="progress" :max="100" show-progress animated class="mt-5"></b-progress>

        <p v-if="!items.length" class="text-muted mb-0" :class="{ 'mt-10': !disabled }">{{ emptyText }}</p>

        <!-- Images: thumbnail grid -->
        <b-row v-if="kind === 'image'" class="media-card__grid">
            <b-col v-for="(item, index) in items" :key="'media' + index" cols="6" md="4" class="media-card__cell">
                <b-img thumbnail fluid :src="urlOf(item)" data-fancybox class="cursor-pointer media-card__thumb"></b-img>

                <b-button v-if="!disabled"
                          variant="danger"
                          class="btn-icon rounded-circle media-card__remove"
                          :title="removeTitle"
                          @click="$emit('remove', item)">
                    <feather-icon icon="Trash2Icon" />
                </b-button>
            </b-col>
        </b-row>

        <!-- Videos / files: list -->
        <div v-else class="card-list mt-10">
            <div v-for="(item, index) in items" :key="'media' + index" class="card-list__item media-card__file">
                <a :href="urlOf(item)" target="_blank" rel="noopener" class="media-card__file-link">
                    <feather-icon icon="FilmIcon" class="mr-5" /> {{ fileName(item) }}
                </a>

                <b-button v-if="!disabled"
                          variant="flat-danger"
                          class="btn-icon rounded-circle tap-target flex-shrink-0"
                          :title="removeTitle"
                          @click="$emit('remove', item)">
                    <feather-icon icon="Trash2Icon" />
                </b-button>
            </div>
        </div>
    </b-card>
</template>

<script>
    /*
     * Image / video upload card. Parent keeps the HTTP calls:
     *
     *   <MediaUploadCard ref="imageUpload" title="Billeder" kind="image" accept="image/*"
     *                    :items="item.images" :progress="imageUploadProgress" :disabled="ended"
     *                    @upload="uploadImage" @remove="deleteImage" />
     *
     * `reset()` clears the file input so parents calling this.$refs.imageUpload.reset() keep working.
     */
    export default {
        props: {
            title: {
                type: String,
                default: 'Billeder'
            },
            items: {
                type: Array,
                default: () => []
            },
            kind: {
                type: String,
                default: 'image' // 'image' | 'video'
            },
            accept: {
                type: String,
                default: 'image/*'
            },
            placeholder: {
                type: String,
                default: 'Upload'
            },
            progress: {
                type: Number,
                default: 0
            },
            disabled: {
                type: Boolean,
                default: false
            },
            removeTitle: {
                type: String,
                default: 'Slet'
            },
            emptyText: {
                type: String,
                default: 'Ingen filer'
            },
            // items may be plain urls or { url } objects
            urlOf: {
                type: Function,
                default: x => (typeof x === 'string' ? x : (x && x.url) || '')
            }
        },
        methods: {
            reset() {
                if (this.$refs.input) {
                    this.$refs.input.reset()
                }
            },
            fileName(item) {
                var url = this.urlOf(item) || ''
                return url.substr(url.lastIndexOf('/') + 1)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .media-card__grid {
        margin-top: 4px;
    }

    .media-card__cell {
        position: relative;
        margin-top: 10px;
    }

    .media-card__thumb {
        width: 100%;
        aspect-ratio: 4 / 3;
        object-fit: cover;
    }

    .media-card__remove {
        position: absolute;
        top: 6px;
        right: 20px;
        width: 36px;
        height: 36px;
        padding: 0 !important;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    }

    .media-card__file {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        padding: 6px 6px 6px 12px;
    }

    .media-card__file-link {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-flex;
        align-items: center;
    }
</style>
